import { Page } from "../../models/models";

export interface AppNotification {
  id: string;
  recipientUserId: string;
  recipientCustomerId: string;
  eventType: number;
  title: string;
  message: string;
  linkUrl: string;
  sourceModule: string;
  sourceEntityId: string | null;
  isRead: boolean;
  readAt: string | null;
  createdDate: string;
}

export interface NotificationPreference {
  id: string;
  eventType: number;
  isInAppEnabled: boolean;
  isEmailEnabled: boolean;
}

export interface UpdateNotificationPreference {
  eventType: number;
  isInAppEnabled: boolean;
  isEmailEnabled: boolean;
}

export interface NotificationsState {
  notifications: AppNotification[];
  unreadCount: number;
  loading: boolean;
  error: string | undefined;
  isPanelOpen: boolean;
}

export interface NotificationPreferencesState {
  preferences: NotificationPreference[];
  loading: boolean;
  actionLoading: boolean;
  error: string | undefined;
}

// --- Notification History types ---

export type ReadFilter = "all" | "unread" | "read";

export enum NotificationHistorySortParameter {
  createdDate = 1,
}

export interface NotificationHistoryQuery {
  search?: string;
  eventTypes?: number[];
  readFilter?: ReadFilter;
  dateFrom?: string;
  dateTo?: string;
  sortBy?: NotificationHistorySortParameter;
  sortDesc?: boolean;
  pageNo: number;
  pageSize: number;
}

export interface NotificationHistoryState {
  query: NotificationHistoryQuery;
  notifications: Page<AppNotification> | null;
  loading: boolean;
  error: string | undefined;
}
